import instance from "../../index";
import {ManagersFilters} from "../../../filters/managers-filters";
import {Gestor} from "../../../models/gestor";
import {BaseResponse} from "../../../models/base-response";
import {PagedList} from "../../../models/paged-list";
import {CreateManagerRequest} from "../../../models/requests/create-manager-request";
import {UpdateManagerRequest} from "../../../models/requests/update-manager-request";
import {BackofficeUserPasswordResult} from "../../../models/backoffice-user-password-result";
import {ChangeBackofficeUserPasswordRequest} from "../../../models/requests/change-backoffice-user-password-request";

const useManagerService = () => {

    async function activateManager(id: string): Promise<Gestor> {
        const response = await instance.put<Gestor>(`/v1/backoffice/managers/${id}/activate`);
        return response.data;
    }

    async function deactiveManager(id: string): Promise<Gestor> {
        const response = await instance.put<Gestor>(`/v1/backoffice/managers/${id}/inactivate`);
        return response.data;
    }

    async function deleteManager(id: string) {
        const response = await instance.delete(`/v1/backoffice/managers/${id}`);
        return response?.data;
    }

    async function getManagerById(id: string): Promise<Gestor> {
        const response = await instance.get<BaseResponse<Gestor>>(`/v1/backoffice/managers/${id}`);
        return response?.data?.data;
    }

    async function getManagers(filter?: ManagersFilters): Promise<PagedList<Gestor>> {
        const response = await instance.get<BaseResponse<PagedList<Gestor>>>('/v1/backoffice/managers/', {
            params: filter
        });
        return response?.data?.data;
    }

    async function createManager(request: Partial<CreateManagerRequest>): Promise<Gestor> {
        const response = await instance.post<Gestor>(`/v1/backoffice/managers/`, request);
        return response?.data;
    }

    async function editManager(request: Partial<UpdateManagerRequest>, id: string | undefined): Promise<Gestor> {
        const response = await instance.put<Gestor>(`/v1/backoffice/managers/${id}`, request);
        return response?.data;
    }

    async function resetManagerPassword(id: string): Promise<BackofficeUserPasswordResult> {
        const response = await instance.put<BaseResponse<BackofficeUserPasswordResult>>(
            `/v1/backoffice/managers/${id}/reset-password`
        );
        return response.data.data;
    }

    async function changeManagerPassword(
        id: string,
        request: ChangeBackofficeUserPasswordRequest
    ): Promise<BackofficeUserPasswordResult> {
        const response = await instance.put<BaseResponse<BackofficeUserPasswordResult>>(
            `/v1/backoffice/managers/${id}/password`,
            request
        );
        return response.data.data;
    }

    return {
        activateManager,
        deactiveManager,
        deleteManager,
        getManagerById,
        getManagers,
        createManager,
        editManager,
        resetManagerPassword,
        changeManagerPassword
    }
}

export default useManagerService;

